import React, { Component } from "react";
import axios from "axios";
import { BrowserRouter, Route, Navigate } from "react-router-dom";
import { Checkbox } from "primereact/checkbox";

import { Panel } from "primereact/panel";
import { AutoComplete } from "primereact/autocomplete";
import Server from "./../Server.js";
import { DataView, DataViewLayoutOptions } from "primereact/dataview";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Dropdown } from "primereact/dropdown";
import { Dialog } from "primereact/dialog";
import { Toast } from "primereact/toast";

import { connect } from "react-redux";
import { max } from "moment-jalaali";
import { Loader } from "rsuite";
import { confirmAlert } from "react-confirm-alert"; // Import
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css
import { Multiselect } from "multiselect-react-dropdown";

class UsersMap extends React.Component {
  constructor(props) {
    super(props);
    this.Server = new Server();
    this.state = {
      layout: "list",
      dashData:
        this.props &&
        this.props.location &&
        this.props.location.state &&
        this.props.location.state.data
          ? this.props.location.state.data
          : [],
      dashList:
        this.props &&
        this.props.location &&
        this.props.location.state &&
        this.props.location.state.list
          ? this.props.location.state.list
          : [],
      NewFactors:
        this.props &&
        this.props.location &&
        this.props.location.state &&
        this.props.location.state.NewFactors
          ? this.props.location.state.NewFactors
          : null,
      NewUsers:
        this.props &&
        this.props.location &&
        this.props.location.state &&
        this.props.location.state.NewUsers
          ? this.props.location.state.NewUsers
          : null,

      GridDataUsers: [],
      GridDataFactors: [],
      visibleDialog: false,
      selectedId: null,
      selectedUser: null,
      levelFilter: null,
      level: "0",
      name: null,
      username: null,
      pass: null,
      pass2: null,
      address: null,
      mail: null,
      creditPrice: false,
      company: null,
      username: null,
      status: "1",
      map: null,
      HasError: null,
      mapList: [],
      levelOfUser: null,
      off: null,
      levelOfUserArray: [],
      ShowNewLevelOfUser: 0,
      levelOfUser2: -1,
      Offs: [],
      PriceOfLevels: [],
      formuls: [],
      formul: null,
      formul_level: "",
      formul_off: "",
      formul_opr: "",
      PriceOfLevel: null,
      LevelOption: [],
      loading: 0,
      selectedSystem: [],
      mySystem: {
        subSystem: false,
      },
      limit: 2,
      skip: 0,
      count: 0,
      first: 0,
      systemId: this.props.systemId || localStorage.getItem("systemId"),
    };
    this.toast = React.createRef();
    this.onHide = this.onHide.bind(this);
    this.selectedUserChange = this.selectedUserChange.bind(this);
    this.EditMap = this.EditMap.bind(this);
    this.handleChangeMap = this.handleChangeMap.bind(this);
  }

  GetMaps() {
    let that = this;
    this.setState({
      loading: 1,
    });
    let param = {
      token: localStorage.getItem("api_token"),
      getAll: true,
    };
    let SCallBack = function (response) {
      that.setState({
        mapList: [
          {
            _id: null,
            name: "",
          },
        ].concat(response.data.result),
        loading: 0,
      });
    };
    let ECallBack = function (error) {
      that.setState({
        loading: 0,
      });
      console.log(error);
    };
    this.Server.send("AdminApi/GetMaps", param, SCallBack, ECallBack);
  }

  EditMap() {
    let that = this;
    this.setState({
      HasError: null,
      loading: 1,
    });
    let param = {
      token: localStorage.getItem("api_token"),
      username: this.state.username,
      systemId: this.state.systemId,
      _id: this.state.selectedId,
      map: this.state.map,
    };
    let SCallBack = function (response) {
      that.setState({
        loading: 0,
      });
      if (response.data.err)
        that.toast.current.show({
          severity: "error",
          summary: "خطا",
          detail: (
            <div>
              <span>{response.data.err}</span>
            </div>
          ),
          life: 8000,
        });
      else {
        that.toast.current.show({
          severity: "success",
          summary: "پیغام موفقیت",
          detail: (
            <div>
              <span>عملیات با موفقیت انجام شد</span>
            </div>
          ),
          life: 8000,
        });

        that.GetUsers();
        that.setState({
          visibleDialog: false,
        });
      }
    };
    let ECallBack = function (error) {
      that.setState({
        loading: 0,
      });
      that.toast.current.show({
        severity: "error",
        summary: "خطا",
        detail: (
          <div>
            <span>عملیات انجام نشد</span>
          </div>
        ),
        life: 8000,
      });
    };
    this.Server.send("AdminApi/changeMap", param, SCallBack, ECallBack);
  }
  handleChangeMap(event) {
    this.setState({ map: event.target.value });
  }
  onHide(event) {
    this.setState({
      visibleDialog: false,
      selectedId: null,
      name: "",
      username: "",
      HasError: null,
      map: null,
    });
  }
  selectedUserChange(value) {
    this.setState({
      selectedId: value._id,
      name: value.name,
      username: value.username,
      map: value.systemOfUser[0].map
        ? value.systemOfUser[0].map
        : value.systemOfUser[0].level == "1"
        ? this.state.mapList[0]?._id
        : null,
      visibleDialog: true,
    });
  }
  componentDidMount() {
    let that = this;
    this.Server.send(
      "MainApi/checktoken",
      {
        token: localStorage.getItem("api_token"),
      },
      function (response) {
        that.setState({
          ShopUserId: response.data.authData.shopId,
        });
        that.GetMaps();

        //that.GetUsers();
      },
      function (error) {}
    );
  }
  GetUsers() {
    let that = this;
    this.setState({
      loading: 1,
    });
    let param = {
      token: localStorage.getItem("api_token"),
      ShopId: this.state.ShopUserId,
      userId: this.state.SearchValue ? this.state.SearchValue : null,
      GetAll: 1,
      systemId:
        this.state.mySystem && this.state.mySystem.subSystem
          ? this.state.mySystem._id
          : null,
      getManagers: true,
      status: "1",
      limit: this.state.limit,
      skip: this.state.skip,
    };

    let SCallBack = function (response) {
      that.setState({
        loading: 0,
      });
      response.data.result.map(function (v, i) {
        v.Radif = i + 1;
        v.edit = (
          <button
            className="btn btn-info irsans"
            onClick={() => that.selectedUserChange(v)}
          >
            ویرایش
          </button>
        );
      });
      that.setState({
        GridDataUsers: response.data.result,
        count: response.data.count,
      });
    };
    let ECallBack = function (error) {
      that.setState({
        loading: 0,
      });
      console.log(error);
    };
    this.Server.send("AdminApi/getuser", param, SCallBack, ECallBack);
  }

  rowClass(data) {
    return {
      "row-highlight1": data.level != 1,
    };
  }

  itemTemplate(brand) {
    return (
      <div
        className="p-clearfix"
        style={{ direction: "rtl", maxWidth: "100%" }}
      >
        <div
          style={{ margin: "10px 10px 0 0" }}
          className="row"
          _id={brand._id}
        >
          <div className="col-8" _id={brand._id} style={{ textAlign: "right" }}>
            <span
              className="iranyekanwebregular"
              style={{ textAlign: "right", overflow: "hidden" }}
              _id={brand._id}
            >
              <span style={{ whiteSpace: "pre-wrap" }} _id={brand._id}>
                {brand.name}
              </span>
              <br />
            </span>
          </div>
        </div>
      </div>
    );
  }

  suggestBrands(event) {
    let that = this;
    this.setState({ brand: event.query, Count: 0 });
    let param = {
      system: this.state.systemId,
      isMainSystem: true,
      title: event.query,
      table: "users",
      name: ["name", "username", "RaymandAcc", "RaymandUser"],
    };

    let SCallBack = function (response) {
      let brandSuggestions = [];
      response.data.result.reverse().map(function (v, i) {
        brandSuggestions.push({ _id: v._id, name: v.name });
      });
      that.setState({ brandSuggestions: brandSuggestions });
    };

    let ECallBack = function (error) {};
    that.Server.send("AdminApi/searchItems", param, SCallBack, ECallBack);
  }

  render() {
    const footer = (
      <div>
        <button
          className="btn btn-primary irsans"
          onClick={() => this.EditMap()}
          style={{ width: "200px", marginTop: "5px", marginBottom: "5px" }}
        >
          {" "}
          اعمال{" "}
        </button>
      </div>
    );
    return (
      <div style={{ direction: "rtl" }}>
        <div className="row justify-content-center mt-2">
          <Toast
            ref={this.toast}
            position="top-left"
            style={{ fontFamily: "YekanBakhFaBold", textAlign: "right" }}
          />
          <div className="row">
            <div
              className="col-lg-6 col-12 mb-5"
              style={{ background: "#fff", textAlign: "right", marginTop: 20 }}
            >
              <AutoComplete
                placeholder="بخشی از نام / شماره موبایل / شناسه کاربری / شماره حساب  را جستجو کنید"
                style={{ width: "100%" }}
                onChange={(event) => {
                  this.setState({ searchName: event.value, SearchValue: null });
                }}
                itemTemplate={this.itemTemplate.bind(this)}
                value={this.state.searchName}
                onSelect={(event) => {
                  this.setState(
                    {
                      limit: 10,
                      skip: 0,
                      count: 0,
                      first: 0,
                      SearchValue: event.value._id,
                      searchName: event.value.name,
                    },
                    () => {
                      this.GetUsers();
                    }
                  );
                }}
                suggestions={this.state.brandSuggestions}
                completeMethod={this.suggestBrands.bind(this)}
              />
            </div>
            <div
              className="col-lg-6 col-12 mb-5"
              style={{ background: "#fff", textAlign: "right", marginTop: 20 }}
            >
              <button
                className="btn btn-info irsans"
                onClick={() => {
                  this.setState(
                    {
                      limit: 10,
                      skip: 0,
                      count: 0,
                      first: 0,
                    },
                    () => {
                      this.GetUsers();
                    }
                  );
                }}
              >
                جستجو
              </button>
            </div>
          </div>
          <div className="col-12" style={{ background: "#fff" }}>
            <Panel
              header="مدیریت کاربران"
              style={{
                textAlign: "right",
                marginBottom: 50,
                fontFamily: "yekan",
              }}
            >
              <DataTable
                rowClassName={this.rowClass}
                rows={this.state.limit}
                lazy
                onPage={(event) => {
                  console.log(event);
                  this.setState(
                    {
                      skip: event.page + 1,
                      first: event.first,
                    },
                    () => {
                      this.GetUsers();
                    }
                  );
                }}
                loading={this.state.loading}
                totalRecords={this.state.count}
                first={this.state.first}
                paginator={true}
                responsive
                ref={(el) => (this.dt = el)}
                value={this.state.GridDataUsers}
                selectionMode="single"
                selection={this.state.selectedUser}
                onSelectionChange={(e) => this.selectedUserChange(e.value)}
              >
                <Column
                  field="username"
                  header="نام کاربری"
                  className="irsans"
                  style={{ textAlign: "right" }}
                  filterMatchMode="contains"
                />
                <Column
                  field="name"
                  header="نام"
                  className="irsans"
                  style={{ textAlign: "right" }}
                  filterMatchMode="contains"
                />
                <Column
                  field="map"
                  header="دسترسی"
                  className="irsans"
                  style={{ textAlign: "right" }}
                />
              </DataTable>
            </Panel>
          </div>
        </div>
        <Dialog
          header="تغییر سطح دسترسی"
          visible={this.state.visibleDialog}
          style={{ width: "50vw" }}
          footer={footer}
          minY={70}
          maxY={400}
          onHide={this.onHide}
          maximizable={false}
        >
          <form
            style={{
              maxWidth: 800,
              maxHeight: 450,
              marginBottom: 10,
              maxWidth: 1000,
            }}
          >
            <div className="row">
              <div className="col-lg-6 col-12">
                <div className="group">
                  <input
                    className="form-control irsans"
                    disabled
                    autoComplete="off"
                    type="text"
                    value={this.state.username}
                    name="username"
                  />
                  <label>نام کاربری</label>
                </div>
              </div>
              <div className="col-lg-6 col-12">
                <div className="group">
                  <input
                    className="form-control irsans"
                    disabled
                    autoComplete="off"
                    type="text"
                    value={this.state.name}
                    name="name"
                  />
                  <label>نام و نام خانوادگی</label>
                </div>
              </div>
              <div className="col-lg-12">
                <label className="labelNoGroup irsans">دسترسی</label>

                <select
                  className="form-control irsans"
                  value={this.state.map}
                  name="map"
                  onChange={this.handleChangeMap}
                >
                  {this.state.mapList &&
                    this.state.mapList.map((v, i) => {
                      return <option value={v._id}>{v.name || v._id}</option>;
                    })}
                </select>
              </div>
            </div>
          </form>
        </Dialog>
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    systemId: state.systemId,
  };
};
export default connect(mapStateToProps)(UsersMap);
